<section class="faq-section">

  <h2 class="faq-heading">Frequently asked <span class="faq-heading--teal">questions</span></h2>

  <div class="faq-list">
    <div
      class="faq-item"
      *ngFor="let item of faqs; let i = index"
      [class.faq-item--open]="item.open"
    >
      <button class="faq-question" (click)="toggle(i)">
        <span>{{ item.question }}</span>
        <span class="faq-icon">{{ item.open ? '▲' : '▼' }}</span>
      </button>
      <div class="faq-answer" *ngIf="item.open">
        <p>{{ item.answer }}</p>
      </div>
    </div>
  </div>

</section>
